import React from "react";
import { headerIcon } from "../../common/constants";
import { NavLink } from "react-router-dom";
import MusicHook from "../wrappers/Music";
import { ConnectWallet } from "../buttons/ConnectWallet";
import { Messages } from "../messages/Messages";

export function GlobalHeader(): React.ReactElement {
  return (
    <div className="global-header">
      <div className="header left"> 
        <div className="header-links">
          <NavLink to={`/home`} className="header-link-button">
            Home
          </NavLink>
          <NavLink to={`/bubos/mint`} className="header-link-button">
            Mint
          </NavLink>
          <NavLink to={`/bubos/wallet`} className="header-link-button">
            Wallet
          </NavLink>
          <NavLink to={`/bubos/team`} className="header-link-button">
            Team
          </NavLink>
        </div>
      </div>
      <div className="header center">
        <div className="header-thumbnail">
          <img 
            className={"header-thumbnail-gif"}
            src={headerIcon}
            alt={"Header Icon"} 
          />
        </div>
      </div>
      <div className="header right">     
        <div className="dapp-information">
          <Messages />
        </div>
        <div className="wallet-button-wrapper">
          <ConnectWallet />
        </div>
        <div className="music-button-wrapper">
          <MusicHook />
        </div>   
      </div>
    </div>
  )
  
}